import { isConditionalParam } from './isConditionalParam';
// TODO: Add tests
export function replaceConditionalParams(params, appSecurityLevel) {
    Object.keys(params).forEach(function (key) {
        var param = params[key];
        if (isConditionalParam(param)) {
            params[key] =
                appSecurityLevel >= param.securityThreshold
                    ? param.defaultValue
                    : param.fallbackValue;
        }
    });
}
//# sourceMappingURL=replaceConditionalParams.js.map